import styles from "./MachineDetailHeader.module.css";

function MachineDetailHeader({machineName, date, workMode}) {
  return (
    <header className={styles.header}>
      <h1 className={styles.machineName}>{machineName}</h1>
      <div className={styles.info}>
        <span className={styles.date}>Date: {date}</span>
        <span className={styles.mode}>Work Mode: {workMode || "-"}</span>
      </div>
    </header>
  );
}

export default MachineDetailHeader;
